import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { UserRole } from '../models/user/user-role.enum';
import { UnsubscribeOnDestroyAdapter } from '../adapters/unsubscibe-on-destroy.adapter';

@Directive({
  selector: '[pscHideIfLoggedIn]'
})
export class HideIfLoggedInDirective extends UnsubscribeOnDestroyAdapter implements OnInit {
  private hideIfLoggedInValue: boolean;

  @Input() set pscHideIfLoggedIn(value: boolean) {
    this.hideIfLoggedInValue = value;
    this.checkAccess();
  }

  roles: UserRole[] | undefined;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.authService.getUserDataObservable().subscribe(() => {
      this.checkAccess();
    });
  }

  checkAccess() {
    this.viewContainer.clear();
    if (!(this.hideIfLoggedInValue && this.authService.getToken())) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
